import { useMutation } from '@tanstack/react-query';
import type { CandidateBoardsMoveBoardPostRequest } from '../types/CandidateBoard';

export default function usePostCandidateBoardsMoveBoard() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  return useMutation({
    mutationFn: async ({ targetBoardId, order_number }: CandidateBoardsMoveBoardPostRequest) => {
      const response = await fetch(`/agent/api/candidate_boards/${targetBoardId}/move_board`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        body: JSON.stringify({
          order_number,
        }),
      });
      const data = await response.json();
      return data;
    },
  });
}
